import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { TextField } from '@mui/material';

export interface CommentInputRef {
    getValue: () => string;
}

interface Props {
    initialValue: string;
    isSubmitting: boolean;
}

const CommentInput = forwardRef<CommentInputRef, Props>(({ initialValue, isSubmitting }, ref) => {
    const [localValue, setLocalValue] = useState(initialValue);

    useEffect(() => {
        setLocalValue(initialValue);
    }, [initialValue]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLocalValue(e.target.value);
    };

    // 👇 Aquí está la magia
    useImperativeHandle(ref, () => ({
        getValue: () => localValue
    }));

    return (
        <TextField
            fullWidth
            multiline
            rows={4.5}
            value={localValue}
            onChange={handleChange}
            placeholder="Escribe tu respuesta..."
            disabled={isSubmitting}
            variant="outlined"
            sx={{ bgcolor: 'white', borderRadius: 2 }}
        />
    );
});

export default React.memo(CommentInput);
